import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
	CommonModule,
	CurrencyPipe,
	DatePipe,
	NgOptimizedImage,
} from '@angular/common';
import {
	NgbAccordionModule,
	NgbAlertModule,
	NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule, routes } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import {
	AuthEffects,
	metaReducers,
	PermissionsEffects,
	reducers,
	UserEffects,
} from './store';
import { extModules } from './build-specifics';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { CredentialsInterceptor } from '@lmc-app/core/interceptors/credentials.interceptor';
import { AuthErrorInterceptor } from '@lmc-app/core/interceptors/auth-error.interceptor';
import { Router, RouterModule } from '@angular/router';
import { AccountSelectComponent } from './account-select/account-select.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ReadComponent } from './read/read.component';
import { MAT_TABS_CONFIG, MatTabsModule } from '@angular/material/tabs';
import { PreApprovalComponent } from './pre-approval/pre-approval.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { UnderwritingdashboardComponent } from './Dashboard/ZOHO/underwritingdashboard/underwritingdashboard.component';
import { CustomFunctionService } from './custom-function.service';
import { NlsdashboardComponent } from './Dashboard/NLS/funded/current/nlsdashboard/nlsdashboard.component';
import { NlsagencyfundedComponent } from './Dashboard/NLS/funded/monthly/nlsagencyfunded/nlsagencyfunded.component';
import { NlsagencycollectorsComponent } from './Dashboard/NLS/funded/monthly/nlsagencycollectors/nlsagencycollectors.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { UnderwritingagencyexceptionComponent } from './Dashboard/ZOHO/underwritingagencyexception/underwritingagencyexception.component';
import { NlscreditorcollectionsComponent } from './Dashboard/NLS/collections/grouped/nlscreditorcollections/nlscreditorcollections.component';
import { NlscreditorcollectionscollectorComponent } from './Dashboard/NLS/collections/grouped/nlscreditorcollectionscollector/nlscreditorcollectionscollector.component';
import { NlsagencycollectionsComponent } from './Dashboard/NLS/collections/grouped/nlsagencycollections/nlsagencycollections.component';
import { NlsagencycollectionscollectorComponent } from './Dashboard/NLS/collections/grouped/nlsagencycollectionscollector/nlsagencycollectionscollector.component';
import { NlsagencycollectionscollectorclientsComponent } from './Dashboard/NLS/collections/grouped/nlsagencycollectionscollectorclients/nlsagencycollectionscollectorclients.component';
import { MatSortModule } from '@angular/material/sort';
import { NlsportfoliocollectionsbreakdownComponent } from './Dashboard/NLS/collections/grouped/nlsportfoliocollectionsbreakdown/nlsportfoliocollectionsbreakdown.component';
import { TopNavComponent } from './top-nav/top-nav.component';
import { CreateApplicationModalComponent } from './top-nav/create-application-modal/create-application-modal.component';
import { SearchModalComponent } from './top-nav/search-modal/search-modal.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ViewUnderwritingComponent } from './view-underwriting/view-underwriting.component';
import { InterviewerqueueComponent } from './Dashboard/ZOHO/interviewerqueue/interviewerqueue.component';
import { ValidatorqueueComponent } from './Dashboard/ZOHO/validatorqueue/validatorqueue.component';
import { UnderwritingTimerstartComponent } from './underwriting-timerstart/underwriting-timerstart.component';
import { MonthlyincomecalcComponent } from './monthlyincomecalc/monthlyincomecalc.component';
import { PhoneMaskDirective } from './phone-mask.directive';
import { ApplicationComponent } from './application/application.component';
import { LoanMetaComponent } from './loan-meta/loan-meta.component';
import { ButtonRendererComponent } from './button-renderer/button-renderer.component';
import { AgGridModule } from 'ag-grid-angular';
import { AmoScheduleComponent } from './loan-meta/amo-schedule/amo-schedule.component';
import { CommentFormComponent } from './comment-form/comment-form.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgSelectModule } from '@ng-select/ng-select';
import { PtpReportComponent } from './Dashboard/NLS/ptp-report/ptp-report.component';
import { UwPerformanceComponent } from './Dashboard/NLS/uw-performance/uw-performance.component';
import { UwDailyStatComponent } from './Dashboard/uw-daily-stat/uw-daily-stat.component';
import { CustomModalComponent } from './custom-modal/custom-modal.component';
import { PtpCreatedReportComponent } from './Dashboard/NLS/ptp-created-report/ptp-created-report.component';
import { NgChartsModule } from 'ng2-charts';
import { ReportsComponent } from './Dashboard/NLS/reports/reports.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { ReportsDashboardComponent } from './Dashboard/NLS/reports/reports-dashboard/reports-dashboard.component';
import { RollOversComponent } from './Dashboard/NLS/reports/roll-overs/roll-overs.component';
import { CurrencyShortFormPipe } from './pipes/currency-short-form.pipe';
import { IntermediaCallReportsComponent } from './tv-custom-dashboards/intermedia-call-reports/intermedia-call-reports.component';
import { CollectionListComponent } from './Dashboard/NLS/collections/collection-list/collection-list.component';
import { CustomTableComponent } from './custom-table/custom-table.component';
import { CustomTooltipComponent } from './custom-table/custom-tooltip/custom-tooltip.component';
import { MenuListItemComponent } from './menu-list-item/menu-list-item.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxPrintModule } from 'ngx-print';
import { FundedTvReportComponent } from './tv-custom-dashboards/funded-tv-report/funded-tv-report.component';
import { CollectionTvReportComponent } from './tv-custom-dashboards/collection-tv-report/collection-tv-report.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SummaryComponent } from './summary/summary.component';
import { SummaryBarComponent } from './summary/summary-bar/summary-bar.component';
import { NotesComponent } from './summary/activities/notes/notes.component';
import { TimelineComponent } from './summary/activities/timeline/timeline.component';
import { HighlightSegmentsPipe } from './summary/activities/timeline/highlight-segments.pipe';
import { ChecklistComponent } from './summary/checklist/checklist.component';
import { UnderwritingComponent } from './summary/underwriting/underwriting.component';
import { LoancalculatorComponent } from './summary/loancalculator/loancalculator.component';
import { TransunionComponent } from './summary/transunion/transunion.component';
import { LoanInterviewComponent } from './summary/loan-interview/loan-interview.component';
import { UnderwritingExceptionComponent } from './summary/underwriting-exception/underwriting-exception.component';
import { IframeViewComponent } from './summary/iframe-view/iframe-view.component';
import { SafePipe } from '@lmc-app/pipes/safe.pipe';
import { MatGridListModule } from '@angular/material/grid-list';
import { PromiseToPayPanelComponent } from './loan-servicing/promise-to-pay/loan/promise-to-pay-panel.component';
import { FundingListComponent } from './loan-servicing/funding-list/funding-list.component';
import { FundingListMomComponent } from './loan-servicing/funding-list-mom/funding-list-mom.component';
import { HierarchyDataComponent } from './hierarchy-data/hierarchy-data.component';
import { MatTreeModule } from '@angular/material/tree';
import { CustomStatsToolPanelComponent } from './custom-table/custom-stats-tool-panel/custom-stats-tool-panel.component';
import { FundingListToolPanelComponent } from './custom-table/funding-list-tool-panel/funding-list-tool-panel.component';
import { ButtonCellRendererComponent } from './custom-table/button-cell-renderer/button-cell-renderer.component';
import { PaymentReportLoanServicingComponent } from './loan-meta/payment-report-loan-servicing/payment-report-loan-servicing.component';
import { AccountInformationComponent } from './loan-servicing/reports/account-information/account-information.component';
import { CurrentAccountInformationComponent } from './loan-servicing/reports/account-information/current-account-information/current-account-information.component';
import { SpvCustomAccountInformationComponent } from './loan-servicing/reports/account-information/spv-custom-account-information/spv-custom-account-information.component';
import { PaymentBreakdownBoardComponent } from './loan-servicing/reports/payment-breakdown-board/payment-breakdown-board.component';
import { MftLpp0876Component } from './loan-servicing/reports/payment-breakdown-board/mft-lpp0876/mft-lpp0876.component';
import { MftLpp4476Component } from './loan-servicing/reports/payment-breakdown-board/mft-lpp4476/mft-lpp4476.component';
import { PaymentBreakdownComponent } from './loan-servicing/reports/payment-breakdown-board/payment-breakdown/payment-breakdown.component';
import { SanityChecksComponent } from './loan-servicing/reports/sanity-checks/sanity-checks.component';
import { AchChecksComponent } from './loan-servicing/reports/sanity-checks/ach-checks/ach-checks.component';
import { AchValidationComponent } from './loan-servicing/reports/sanity-checks/ach-validation/ach-validation.component';
import { DailyReconComponent } from './loan-servicing/reports/sanity-checks/daily-recon/daily-recon.component';
import { BalloonPaymentsComponent } from './loan-servicing/reports/sanity-checks/balloon-payments/balloon-payments.component';
import { ExpiredAchComponent } from './loan-servicing/reports/sanity-checks/expired-ach/expired-ach.component';
import { NsfCollectionListComponent } from './Dashboard/NLS/nsf-collection-list/nsf-collection-list.component';
import { CustomButtonComponent } from './custom-button/custom-button.component';
import { HomeDashboardComponent } from './Dashboard/home-dashboard/home-dashboard.component';
import { CollectionDasboardMetricsComponent } from './Dashboard/home-dashboard/collection-dasboard-metrics/collection-dasboard-metrics.component';
import { CustomBettyReportFiltersComponent } from './loan-servicing/reports/custom-betty-report-filters/custom-betty-report-filters.component';
import { LppReportsComponent } from './loan-servicing/reports/lpp-reports/lpp-reports.component';
import { LppClaimsComponent } from './loan-servicing/reports/lpp-reports/lpp-claims/lpp-claims.component';
import { LppCancellationComponent } from './loan-servicing/reports/lpp-reports/lpp-cancellation/lpp-cancellation.component';
import { InsuranceRemitComponent } from './loan-servicing/reports/lpp-reports/insurance-remit/insurance-remit.component';
import { PtpCollectionListComponent } from './Dashboard/NLS/collections/ptp-collection-list/ptp-collection-list.component';
import { CollectionsComponent } from './Dashboard/NLS/collections/collections.component';
import { PtpDateReportComponent } from './general-reports/ptp-date-report/ptp-date-report.component';
import { PtpDateBasedComponent } from './general-reports/ptp-date-report/ptp-date-based/ptp-date-based.component';
import { ArrangementDateBasedComponent } from './general-reports/ptp-date-report/arrangement-date-based/arrangement-date-based.component';
import { MyInnerRendererComponent } from './custom-table/my-inner-renderer/my-inner-renderer.component';
import { CustomExportExcelComponent } from './custom-export-excel/custom-export-excel.component';
import { AdminSettingsComponent } from './admin-settings/admin-settings.component';
import { AssignCollectorsComponent } from './admin-settings/assign-collectors/assign-collectors.component';
import { LockedAccountsComponent } from './admin-settings/locked-accounts/locked-accounts.component';
import { BettyComponent } from './betty/betty.component';
import { LoanValidationComponent } from './betty/loan-validation/loan-validation.component';
import { InsuranceTransCancellationComponent } from './loan-servicing/insurance-trans-cancellation/insurance-trans-cancellation.component';
import { NsfReportsDateComponent } from './loan-servicing/reports/payment-breakdown-board/nsf-reports-date/nsf-reports-date.component';
import { RapidProgramComponent } from './betty/rapid-program/rapid-program.component';
import { TransunionConsentFormComponent } from './betty/transunion-consent-form/transunion-consent-form.component';
import { ZeroBalanceComponent } from './loan-servicing/reports/sanity-checks/zero-balance/zero-balance.component';
import { MultipleStatusCodeComponent } from './loan-servicing/reports/sanity-checks/multiple-status-code/multiple-status-code.component';
import { LoginInquiryModalComponent } from './login/login-inquiry-modal/login-inquiry-modal.component';
import { ExternalDashboardComponent } from './Dashboard/home-dashboard/external-dashboard/external-dashboard.component';
import { BankingSummaryComponent } from './summary/banking-summary/banking-summary.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import { OldLoanCalculatorComponent } from './summary/old-loan-calculator/old-loan-calculator.component';
import { LoanCalculatorV1Component } from './summary/loan-calculator-v1/loan-calculator-v1.component';
import { RapidFilesComponent } from './Dashboard/ZOHO/rapid-files/rapid-files.component';
import { RapidFilesZohoComponent } from './Dashboard/ZOHO/rapid-files/rapid-files-zoho/rapid-files-zoho.component';
import { RapidFilesPortalComponent } from './Dashboard/ZOHO/rapid-files/rapid-files-portal/rapid-files-portal.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { DeleteDocumentDialog } from './applications/delete-document-dialog';
import { FundingListDashboardComponent } from './Dashboard/funding-list-dashboard/funding-list-dashboard.component';
import { MyFundedDealsDashboardComponent } from './Dashboard/my-funded-deals-dashboard/my-funded-deals-dashboard.component';
import { LoanStagingComponent } from './Dashboard/NLS/admin-reports/loan-staging/loan-staging.component';
import { AccruedInterestComponent } from './Dashboard/NLS/admin-reports/accrued-interest/accrued-interest.component';
import { LoanGroupTransferAccruedComponent } from './Dashboard/NLS/admin-reports/loan-group-transfer-accrued/loan-group-transfer-accrued.component';
import { LoanMovementComponent } from './Dashboard/NLS/admin-reports/loan-movement/loan-movement.component';
import { AdminReportLoansComponent } from './Dashboard/NLS/admin-reports/loans/admin-report-loans.component';
import { AccountSettingsComponent } from './admin-settings/account-settings/account-settings.component';
import { SahaExceptionComponent } from './Dashboard/NLS/reports/saha-exception/saha-exception.component';
import { FundingExceptionComponent } from './Dashboard/NLS/reports/funding-exception/funding-exception.component';
import { LegalFeeExceptionModalComponent } from './summary/loancalculator/legal-fee-exception-modal/legal-fee-exception-modal.component';
import { CreateNoteModalComponent } from './summary/activities/notes/create-note-modal/create-note-modal.component';
import { ReadyForLoanInterviewComponent } from './Dashboard/ZOHO/underwritingdashboard/ready-for-loan-interview/ready-for-loan-interview.component';
import { BudgetAssessmentComponent } from './Dashboard/ZOHO/underwritingdashboard/budget-assessment/budget-assessment.component';
import { FileReviewComponent } from './Dashboard/ZOHO/underwritingdashboard/file-review/file-review.component';
import { ScheduledLoanInterviewsComponent } from './Dashboard/ZOHO/underwritingdashboard/scheduled-loan-interviews/scheduled-loan-interviews.component';
import { UnderwritingChecklistComponent } from './Dashboard/ZOHO/underwritingdashboard/underwriting-checklist/underwriting-checklist.component';
import { RapidUnderwritingComponent } from './Dashboard/ZOHO/underwritingdashboard/rapid-underwriting/rapid-underwriting.component';
import { NeedsCopappComponent } from './Dashboard/ZOHO/underwritingdashboard/needs-copapp/needs-copapp.component';
import { AobComponent } from './Dashboard/ZOHO/underwritingdashboard/aob/aob.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { CommonDialog } from '@lmc-app/shared/components/dialog/common-dialog';
import { BankingComponent } from './summary/fulfillment/banking/banking.component';
import { EditableInputView } from '@lmc-app/shared/components/editable-input-view/editable-input-view';
import { WorkdriveComponent } from './summary/fulfillment/workdrive/workdrive.component';
import { PandadocComponent } from './summary/fulfillment/pandadoc/pandadoc.component';
import { FulfillmentComponent } from './summary/fulfillment/fulfillment.component';
import { ApplicationsComponent } from './applications/applications.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { DigitsOnlyDirective } from '@lmc-app/shared/directives/digits-only.directive';
import { ScrollToTopButton } from '@lmc-app/shared/components/scroll-to-top/scroll-to-top.button';
import { TimeRangePickerComponent } from '@lmc-app/shared/components/time-range-picker/time-range-picker.component';
import { GooglePlacesDirective } from '@lmc-app/shared/directives/google-places.directive';
import { ActivitiesComponent } from './summary/activities/activities.component';
import { CallComponent } from './summary/activities/call/call.component';
import { EmailComponent } from './summary/activities/email/email.component';
import { DetailsComponent } from './summary/details/details.component';
import { ECModalComponent } from './shared/formly/types/ec-modal/ec-modal.component';
import { RapidConsentModalComponent } from './summary/rapid-consent-modal/rapid-consent-modal.component';
import { RapidApplicationModalComponent } from './summary/rapid-application-modal/rapid-application-modal.component';
import { RapidCreditorsModalComponent } from './summary/rapid-creditors-modal/rapid-creditors-modal.component';
import { RapidResultModalComponent } from './summary/rapid-result-modal/rapid-result-modal.component';
import { SendEmailFormComponent } from './summary/activities/email/send-email-form.component';
import { AutoSaveStatusComponent } from '@lmc-app/shared/components/auto-save-status/auto-save-status.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StateDisplayComponent } from '@lmc-app/shared/components/state-display/state-display.component';
import { StatusBreakdownComponent } from '@lmc-app/shared/components/status-breakdown/status-breakdown.component';
import { CurrencyInputDirective } from './directives/currency-input.directive';
import { CoappObtainedComponent } from './Dashboard/ZOHO/underwritingdashboard/coapp-obtained/coapp-obtained.component';
import { ThumbnailComponent } from '@lmc-app/shared/components/thumbnail/thumbnail.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NotificationDialogComponent } from '@lmc-app/shared/components/notification-dialog/notification-dialog.component';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { ApplicationCallsComponent } from '@lmc-app/Dashboard/application-calls/application-calls.component';
import { CustomAssignCollectorsComponent } from './Dashboard/NLS/collections/collection-list/custom-assign-collectors/custom-assign-collectors.component';
import { PartialWaiveoffModalComponent } from './summary/loancalculator/partial-waiveoff-modal/partial-waiveoff-modal.component';
import { FundedDetailsModalComponent } from './summary/loancalculator/funded-details-modal/funded-details-modal.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CreateAccountComponent } from './admin-settings/account/create-account/create-account.component';
import { AccountsComponent } from './admin-settings/account/accounts.component';
import { UpdateAccountComponent } from './admin-settings/account/update-account/update-account.component';
import { ResetPasswordModalComponent } from './admin-settings/account/reset-password-modal/reset-password-modal.component';
import { ReportQueueComponent } from './loan-servicing/report-queue/report-queue.component';
import { ReadReportModalComponent } from './loan-servicing/report-queue/read-report-modal/read-report-modal.component';
import { DebuggingComponent } from './admin-settings/debugging/debugging.component';
import { PaymentProcessingComponent } from './admin-settings/payment-processing/payment-processing.component';
import { DesignSystemComponent } from './design-system/design-system.component';
import { NavVisibilityDirective } from '@lmc-app/shared/directives/nav-visibility.directive';
import * as Sentry from '@sentry/angular';
import { ExternalApiClientsComponent } from './admin-settings/external-api-clients/external-api-clients.component';
import { LoanCalculatorScriptComponent } from './summary/loancalculator/loan-calculator-script/loan-calculator-script.component';
import { EnvironmentInfoDialogComponent } from './top-nav/environment-info-dialog/environment-info-dialog.component';
import { AppFormlyModule } from '@lmc-app/shared/formly/formly.module';
import { DataLoaderComponent } from './shared/components/data-loader/data-loader.component';
import { TransactionListComponent } from './loan-servicing/payment-processing/list/transaction-list.component';
import { TransactionBatchComponent } from './loan-servicing/payment-processing/detail/transaction-batch.component';
import { BackgroundTaskIndicatorComponent } from './shared/components/background-task-indicator/background-task-indicator.component';
import { MatDividerModule } from '@angular/material/divider';
import { FinancialEvaluationComponent } from './summary/financial-evaluation/financial-evaluation.component';
import { SaveAlertComponent } from './shared/components/save-alert/save-alert.component';
import { NlsSettingsComponent } from './loan-servicing/nls-settings/nls-settings.component';
import { SharedLoanMetaModalComponent } from './loan-meta/shared-loan-meta-modal/shared-loan-meta-modal.component';
import { DocusignComponent } from './summary/docusign/docusign.component';
import { EditDocusignEnvelopeComponent } from './summary/docusign/edit-docusign-envelope/edit-docusign-envelope.component';
import { ConfirmDocusignDialogComponent } from './summary/docusign/confirm-docusign-dialog/confirm-docusign-dialog.component';
import { PreviewDocusignModalComponent } from './summary/docusign/preview-docusign-modal/preview-docusign-modal.component';
import { DocusignDeliveryOptionComponent } from './summary/docusign/docusign-delivery-option/docusign-delivery-option.component';
import { AgreementsComponent } from './summary/docusign/agreements/agreements.component';
import { AgreementsValidationComponent } from './summary/docusign/agreements/agreements-validation/agreements-validation.component';
import { AgreementsRecipientsComponent } from './summary/docusign/agreements/agreements-recipients/agreements-recipients.component';
import { AgreementsListComponent } from './summary/docusign/agreements/agreements-list/agreements-list.component';
import { AgreementPreviewModalComponent } from './summary/docusign/agreements/agreement-preview-modal/agreement-preview-modal.component';
import { AgreementsVoidComponent } from './summary/docusign/agreements/agreements-void/agreements-void.component';
import { AgreementsCalculatorModalComponent } from './summary/docusign/agreements/agreements-calculator-modal/agreements-calculator-modal.component';
import { CaPendingVoeComponent } from './Dashboard/ZOHO/underwritingdashboard/ca-pending-voe/ca-pending-voe.component';
import { AgreementsRecipientStatusComponent } from './summary/docusign/agreements/agreements-recipient-status/agreements-recipient-status.component';
import { DocusignGuideComponent } from './summary/docusign/docusign-guide/docusign-guide.component';
import { CorrectRecipientDeliveryComponent } from './summary/docusign/agreements/agreements-recipient-status/correct-recipient-delivery/correct-recipient-delivery.component';
import { AgreementContentUpdateComponent } from './summary/docusign/agreements/agreement-content-update/agreement-content-update.component';
import { MultiSelectSearchComponent } from './shared/components/multi-select-search/multi-select-search.component';
import { AgreementSettingsComponent } from './admin-settings/agreement-settings/agreement-settings.component';
import { LoanAmendmentDialogComponent } from './summary/docusign/loan-amendment-dialog/loan-amendment-dialog.component';
import { UserPickerComponent } from './shared/components/user-picker/user-picker.component';
import { PandadocPreviewModalComponent } from './summary/fulfillment/pandadoc/pandadoc-preview-modal/pandadoc-preview-modal.component';

@NgModule({
	declarations: [
		DeleteDocumentDialog,
		DesignSystemComponent,
		PhoneMaskDirective,
		AppComponent,
		TransunionComponent,
		AccountSelectComponent,
		LoancalculatorComponent,
		ReadComponent,
		PreApprovalComponent,
		SummaryComponent,
		UnderwritingdashboardComponent,
		NlsdashboardComponent,
		NlsagencyfundedComponent,
		NlsagencycollectorsComponent,
		LoginComponent,
		HomeComponent,
		UnderwritingagencyexceptionComponent,
		UnderwritingComponent,
		NlscreditorcollectionsComponent,
		NlscreditorcollectionscollectorComponent,
		NlsagencycollectionsComponent,
		NlsagencycollectionscollectorComponent,
		NlsagencycollectionscollectorclientsComponent,
		NlsportfoliocollectionsbreakdownComponent,
		TopNavComponent,
		CreateApplicationModalComponent,
		SearchModalComponent,
		ViewUnderwritingComponent,
		InterviewerqueueComponent,
		ValidatorqueueComponent,
		UnderwritingTimerstartComponent,
		LoanInterviewComponent,
		MonthlyincomecalcComponent,
		UnderwritingExceptionComponent,
		NotesComponent,
		TimelineComponent,
		HighlightSegmentsPipe,
		CreateNoteModalComponent,
		ApplicationComponent,
		LoanMetaComponent,
		ButtonRendererComponent,
		AmoScheduleComponent,
		CommentFormComponent,
		SummaryBarComponent,
		ChecklistComponent,
		PandadocComponent,
		PtpReportComponent,
		UwPerformanceComponent,
		UwDailyStatComponent,
		CustomModalComponent,
		ReportsComponent,
		ReportsDashboardComponent,
		RollOversComponent,
		CurrencyShortFormPipe,
		SafePipe,
		PtpCreatedReportComponent,
		IntermediaCallReportsComponent,
		CollectionListComponent,
		CustomTableComponent,
		CustomTooltipComponent,
		MenuListItemComponent,
		IframeViewComponent,
		FundingListComponent,
		FundingListMomComponent,
		HierarchyDataComponent,
		CustomStatsToolPanelComponent,
		FundingListToolPanelComponent,
		ButtonCellRendererComponent,
		PaymentReportLoanServicingComponent,
		FundedTvReportComponent,
		CollectionTvReportComponent,
		CurrentAccountInformationComponent,
		SpvCustomAccountInformationComponent,
		AccountInformationComponent,
		PaymentBreakdownBoardComponent,
		MftLpp0876Component,
		MftLpp4476Component,
		PaymentBreakdownComponent,
		SanityChecksComponent,
		AchChecksComponent,
		AchValidationComponent,
		DailyReconComponent,
		BalloonPaymentsComponent,
		ExpiredAchComponent,
		NsfCollectionListComponent,
		CustomButtonComponent,
		NsfCollectionListComponent,
		HomeDashboardComponent,
		CollectionDasboardMetricsComponent,
		CustomBettyReportFiltersComponent,
		LppReportsComponent,
		LppClaimsComponent,
		LppCancellationComponent,
		InsuranceRemitComponent,
		PtpCollectionListComponent,
		CollectionsComponent,
		PtpDateReportComponent,
		PtpDateBasedComponent,
		ArrangementDateBasedComponent,
		MyInnerRendererComponent,
		CustomExportExcelComponent,
		AdminSettingsComponent,
		AssignCollectorsComponent,
		LockedAccountsComponent,
		BettyComponent,
		LoanValidationComponent,
		InsuranceTransCancellationComponent,
		NsfReportsDateComponent,
		RapidProgramComponent,
		TransunionConsentFormComponent,
		ZeroBalanceComponent,
		MultipleStatusCodeComponent,
		LoginInquiryModalComponent,
		ExternalDashboardComponent,
		BankingSummaryComponent,
		OldLoanCalculatorComponent,
		LoanCalculatorV1Component,
		RapidFilesComponent,
		RapidFilesZohoComponent,
		RapidFilesPortalComponent,
		ApplicationsComponent,
		WorkdriveComponent,
		SahaExceptionComponent,
		FundingExceptionComponent,
		FundingListDashboardComponent,
		MyFundedDealsDashboardComponent,
		LoanStagingComponent,
		AccruedInterestComponent,
		LoanGroupTransferAccruedComponent,
		LoanMovementComponent,
		AdminReportLoansComponent,
		LegalFeeExceptionModalComponent,
		ReadyForLoanInterviewComponent,
		BudgetAssessmentComponent,
		FileReviewComponent,
		ScheduledLoanInterviewsComponent,
		UnderwritingChecklistComponent,
		RapidUnderwritingComponent,
		NeedsCopappComponent,
		AobComponent,
		AccountSettingsComponent,
		SahaExceptionComponent,
		LegalFeeExceptionModalComponent,
		BankingComponent,
		CommonDialog,
		EditableInputView,
		FulfillmentComponent,
		DigitsOnlyDirective,
		ActivitiesComponent,
		CallComponent,
		EmailComponent,
		DetailsComponent,
		ECModalComponent,
		RapidConsentModalComponent,
		RapidApplicationModalComponent,
		RapidCreditorsModalComponent,
		RapidResultModalComponent,
		SendEmailFormComponent,
		AutoSaveStatusComponent,
		BudgetAssessmentComponent,
		FileReviewComponent,
		NeedsCopappComponent,
		RapidUnderwritingComponent,
		ReadyForLoanInterviewComponent,
		ScheduledLoanInterviewsComponent,
		UnderwritingChecklistComponent,
		CurrencyInputDirective,
		CoappObtainedComponent,
		NotificationDialogComponent,
		ApplicationCallsComponent,
		CustomAssignCollectorsComponent,
		PartialWaiveoffModalComponent,
		FundedDetailsModalComponent,
		CreateAccountComponent,
		AccountsComponent,
		UpdateAccountComponent,
		ResetPasswordModalComponent,
		NavVisibilityDirective,
		ReportQueueComponent,
		ReadReportModalComponent,
		DebuggingComponent,
		ExternalApiClientsComponent,
		PaymentProcessingComponent,
		LoanCalculatorScriptComponent,
		EnvironmentInfoDialogComponent,
		DataLoaderComponent,
		FinancialEvaluationComponent,
		SaveAlertComponent,
		NlsSettingsComponent,
		SharedLoanMetaModalComponent,
		DocusignComponent,
		EditDocusignEnvelopeComponent,
		ConfirmDocusignDialogComponent,
		PreviewDocusignModalComponent,
		DocusignDeliveryOptionComponent,
		AgreementsComponent,
		AgreementsValidationComponent,
		AgreementsListComponent,
		AgreementPreviewModalComponent,
		AgreementsVoidComponent,
		AgreementsCalculatorModalComponent,
		AgreementsVoidComponent,
  		CaPendingVoeComponent,
    	AgreementsRecipientStatusComponent,
     AgreementContentUpdateComponent,
     MultiSelectSearchComponent,
     AgreementSettingsComponent,
     LoanAmendmentDialogComponent,
		PandadocPreviewModalComponent,
	],
	imports: [
		TransactionListComponent,
		TransactionBatchComponent,
		BackgroundTaskIndicatorComponent,
		PromiseToPayPanelComponent,
		BrowserAnimationsModule,
		NgxExtendedPdfViewerModule,
		NgMultiSelectDropDownModule,
		NgSelectModule,
		AgGridModule,
		NgbAlertModule,
		NgbPaginationModule,
		NgbAccordionModule,
		MatToolbarModule,
		MatChipsModule,
		MatListModule,
		MatTabsModule,
		MatSlideToggleModule,
		MatCheckboxModule,
		MatDialogModule,
		CommonModule,
		MatInputModule,
		MatNativeDateModule,
		HttpClientModule,
		BrowserModule,
		AppRoutingModule,
		MatCardModule,
		MatFormFieldModule,
		MatSelectModule,
		MatIconModule,
		MatDatepickerModule,
		FormsModule,
		ReactiveFormsModule,
		MatButtonModule,
		MatSortModule,
		NgChartsModule,
		RouterModule.forRoot(routes),
		MatProgressSpinnerModule,
		StoreModule.forRoot(reducers, { metaReducers }),
		StoreDevtoolsModule.instrument({
			maxAge: 25,
			logOnly: false, // environment.production
			autoPause: true,
			trace: false,
			traceLimit: 75,
		}),
		EffectsModule.forRoot([AuthEffects, UserEffects, PermissionsEffects]),
		NgxPaginationModule,
		extModules,
		NgChartsModule,
		MatSidenavModule,
		MatStepperModule,
		MatExpansionModule,
		MatGridListModule,
		MatTreeModule,
		NgxPrintModule,
		MatProgressBarModule,
		MatRadioModule,
		MatSnackBarModule,
		MatBottomSheetModule,
		MatTableModule,
		MatMenuModule,
		MatPaginatorModule,
		MatMenuModule,
		MatButtonToggleModule,
		MatNativeDateModule,
		NgxMaskDirective,
		NgxMaskPipe,
		ScrollToTopButton,
		TimeRangePickerComponent,
		GooglePlacesDirective,
		NgxMatSelectSearchModule,
		UserPickerComponent,
		AngularFireModule.initializeApp({
			apiKey: 'AIzaSyC__iUcS6cPfeUCpILVp5PQTTbOd_hQeZQ',
			authDomain: 'lmcredit-testing.firebaseapp.com',
			projectId: 'lmcredit-testing',
			storageBucket: 'lmcredit-testing.firebasestorage.app',
			messagingSenderId: '708345846541',
			appId: '1:708345846541:web:637466ae2a4dc972acee44',
			measurementId: 'G-H4RHQF32MC',
		}),
		AngularFireMessagingModule,
		StateDisplayComponent,
		StatusBreakdownComponent,
		MatPaginatorModule,
		ThumbnailComponent,
		NgxSkeletonLoaderModule,
		MatTooltipModule,
		MatDividerModule,
		NgxMatTimepickerModule,
		NgOptimizedImage,
		DragDropModule,
		AppFormlyModule,
  		AgreementsRecipientsComponent,
    	DocusignGuideComponent,
		CorrectRecipientDeliveryComponent
	],
	exports: [MatFormFieldModule, MatInputModule, PhoneMaskDirective],
	providers: [
		DatePipe,
		CurrencyPipe,
		LegacyApiService,
		CustomFunctionService,
		provideNgxMask(),
		{
			provide: MAT_TABS_CONFIG,
			useValue: { animationDuration: '0ms' }, // Set your desired duration here
		},
		// Sentry
		{
			provide: ErrorHandler,
			useValue: Sentry.createErrorHandler({
				showDialog: false,
			}),
		},
		{
			provide: Sentry.TraceService,
			deps: [Router],
		},
		{
			provide: APP_INITIALIZER,
			useFactory: () => () => {},
			deps: [Sentry.TraceService],
			multi: true,
		},
		// HTTP Interceptors
		{
			provide: HTTP_INTERCEPTORS,
			useClass: CredentialsInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthErrorInterceptor,
			multi: true,
		},
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
